<ul class="navbar-nav">
    <li class="menu-item" [ngClass]="item.child == true ? 'menu-item-has-children' : ''"
        *ngFor="let item of navigation">
        <a href="javascript:void(0)" *ngIf="item.child">{{item.linkText}}</a>
        <a routerLink="{{item.link}}" *ngIf="!item.child">{{item.linkText}}</a>
    </li>
</ul>